import { ValidationMessage, SEVERITY_INFO } from './ValidationMessage';

export class Info extends ValidationMessage {
    constructor(fieldName, message) {
        super(SEVERITY_INFO, message, fieldName);
    }
}